export const env = {
  aiInstrumentationKey: import.meta.env.VITE_INSTRUMENTATION_KEY,
} as const;
